import React from 'react';
import {Box, Button, Grid} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import {MetaTags} from 'react-meta-tags';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';
  
const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

	var vertical='top',horizontal='center';

  export default function Execute(props) {
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}
	const classes = useStyles();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));	
	const [type, setType] = React.useState("noselect");
	const [subject, setSubject] = React.useState("");
	const [details, setDetails] = React.useState("");
	const [saveLoading, setSaveLoading] = React.useState(false);
  	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [typeList, setTypeList] = React.useState([]);

	function hideAlert(){
		setShowAlert(false);
	}
	
	function feedback(){    
		if(type==='noselect'){
			setSeverityAlert("error");
			setShowAlert(true);
			setAlertMessage("Select type");			
			return false;
		}
		if(!subject){
		  setSeverityAlert("error");
		  setShowAlert(true);
		  setAlertMessage("Enter subject");			
		  return false;
		}  
		if(!details){
		  setSeverityAlert("error");
		  setShowAlert(true);
		  setAlertMessage("Enter details");			
		  return false;
		}
		
		if(subject && subject.length>1){ 
		  	setSaveLoading(true);
	
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
		  
		const data = new FormData();
		data.append('type', type);
		data.append('subject', subject);
		data.append('details', details);
		  
		  let apiURL='/student-feedback';
				 
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				setSaveLoading(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setType("noselect");
					setSubject("");
					setDetails("");				
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Feedback has been submitted successfully.");

					const myTimeout = setTimeout(goToDashboard, 2500);
					function goToDashboard() {
						clearTimeout(myTimeout);
						window.location.href='dashboard';
					}
					return false;

				}else if(response.data.responseTxt==="invalidToken"){
					window.localStorage.removeItem('etlStudentObj');  
					window.localStorage.clear(); 
					window.location.href='logout';
				 
				}else{
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Feedback could not be submitted.");			
					return false;
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})	
			}		
		}
	

	React.useEffect(() => {		
		getApiData();
	}, []);

	async function getApiData(){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};

			axios.get(API_URL+'/feedbacktypes', axiosHeader)
			   .then(response => {					
			 	///console.log("Just Checking >> "+response.data);  
				 if(response.data && response.data.responseTxt==='success'){
					setTypeList(response.data.obj);	

			   	}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.removeItem('etlStudentObj');  
					window.localStorage.clear(); 
					window.location.href='logout';
				
			   	}				 				 				
			})
	}

	return (
		<div> 
				<MetaTags>
            		<title>Feedback</title>
          		</MetaTags>
				
				  <Header />	
	   			  <LeftDrawer />
				<main className={classes.content}>  
				
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >Feedback</h3>
								</Grid>
							</Grid>
					</Box>

					<Box mt={1}>
						<Grid container spacing={2}>						
								
							<Grid item md={12} xs={12}>
									<FormControl fullWidth>
										<InputLabel id="demo-simple-select-label">Regarding</InputLabel>
										<Select 
											style={{width:'100%'}}
											labelId="select-class-label"
											id="select-class"
											value={type}
											label="Regarding"									
											onChange={event => setType(event.target.value)}											
										>
											<MenuItem value="noselect">Select Type</MenuItem>
											{typeList?typeList.map((row,index)=>(										
												<MenuItem key={'mi'+index} value={row.title} >{row.title}</MenuItem>
											)):null}
										</Select>
									</FormControl>
								</Grid>
								<Grid item md={12} xs={12}>
									<TextField
										value={subject}
										onChange={event => setSubject(event.target.value)}
										id="ssssubject"
										label="Subject"
										fullWidth
									/>
								</Grid>
								<Grid item md={12} xs={12}>
									<TextField
										value={details}
										onChange={event => setDetails(event.target.value)}
										id="dddetail"
										label="Brief Detail"
										multiline                  
										rows={4}
										fullWidth
									/>
								</Grid>

							<Box mt={2}>
			    	        {saveLoading?
                          		<LoadingButton loading={saveLoading} loadingPosition='start' startIcon={<div style={{marginRight:15}} ></div>} style={{backgroundColor:'#ffa500',color:'#000',marginLeft:10}} size="small" variant="contained"  >Wait...</LoadingButton>
					    	:
                          		<Button onClick={() => {feedback()}} style={{backgroundColor:'#008000',color:'#FFF',marginLeft:10}} size="small" variant="contained"  >Submit</Button>
                          	}
	                        </Box>

						</Grid>
					</Box>

				</Box>
				</main>			

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={16000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

		</div>	
	);
  }